<template>
  <div class="page">
    <div class="list">
      <img-text-row v-for="(item, index) in 50" :key="index"></img-text-row>
    </div>
    
  </div>
</template>

<script>
import imgTextRow from '@/components/img-text-block/img-text-block.vue'

export default {
  name: 'ProductList',
  components: {imgTextRow},
  props: {},
  data() {
    return {
      aa:{}
    }
  },
  watch: {
    aa:{
      handler(newValue, oldValue){
          console.log(newValue,oldValue)
      },
       deep:true // 深度监听表单
    },
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.page{
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
 
   -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */

  .list{
    width: 100%;
    height: 100%;
    padding: 10px;
    // overflow: hidden;
  }
}
</style>
